/**
 * Hook đăng xuất và chuyển hướng về trang chủ.
 *
 * Tránh gọi logout trùng lặp khi isLoggingOut = true.
 * Hỗ trợ callback onBeforeLogout (ví dụ: đóng menu mobile).
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { APP_ROUTES } from '../shared/constants/routes';

/**
 * Trả về hàm logout async — gọi logout rồi navigate về home.
 * @param {Object} [options]
 * @param {Function} [options.onBeforeLogout] - Callback chạy trước khi logout
 * @returns {Function} Hàm logout và redirect
 */
export const useLogoutAndRedirect = ({ onBeforeLogout } = {}) => {
  const { logout, isLoggingOut } = useAuth();
  const navigate = useNavigate();

  return useCallback(async () => {
    if (isLoggingOut) {
      return;
    }

    onBeforeLogout?.();
    await logout();
    navigate(APP_ROUTES.home);
  }, [isLoggingOut, logout, navigate, onBeforeLogout]);
};
